import { FunctionComponent, useEffect, useCallback } from "react";
import { CheckIcon, CloseIcon } from "@form/components/common/icons";
import useAccount from "@/hooks/useAccount";
import useVerifyClaim from "@/hooks/useVerifyClaim";
import { EmailIcon } from "@form/components/common/icons";
import useUserEmail from "@/form/hooks/useUserEmail";
import { validateEmail } from "@form/utils/validate";
import { useTypedSelector } from "@/stores";
import { TextInput, Loader } from "@mantine/core";
import { revokeEmail } from "@/form/services/account";
import { confirm } from "@form/services/modal";

const EmailVerify: FunctionComponent = () => {
  const { isLogin, login } = useAccount();
  const { result, changeVerifyState } = useVerifyClaim("account_email");
  const userInfo = useTypedSelector((state) => {
    return state.account.userInfo;
  });

  const verifyed = result["account_email"] && isLogin;

  const { email, setEmail, verify, verifying } = useUserEmail(true);

  const isEmailValid = validateEmail(email);

  useEffect(() => {
    changeVerifyState(!!userInfo?.email);
  }, [userInfo?.email]);

  const sendEmail = useCallback(() => {
    if (!isEmailValid) {
      return;
    }
    if (!isLogin) {
      return login();
    }
    verify();
  }, [isLogin, verify, isEmailValid]);

  const disconnect = useCallback(async () => {
    await revokeEmail();
  }, []);

  let rightSection = null as any;

  if (!userInfo?.email) {
    if (verifying) {
      rightSection = (
        <div className="flex justify-end w-full pr-3">
          <Loader size="xs"></Loader>
        </div>
      );
    } else {
      rightSection = (
        <div
          className={`text-body font-bold text-primary action translate-x-8 ${
            isEmailValid ? "" : "opacity-50 hover:cursor-not-allowed"
          }`}
          onClick={sendEmail}
        >
          bind
        </div>
      );
    }
  } else {
    rightSection = (
      <div
        className="action translate-x-10 ml-1 w-[14px] h-[14px] rounded-full bg-primary flex items-center justify-center"
        onClick={() => {
          confirm({
            title: "Are you sure to disconnect your account?",
            okText: "Disconnect",
            okType: "danger",
            onOk() {
              disconnect();
            },
          });
        }}
      >
        <CloseIcon className="w-[6px]"></CloseIcon>
      </div>
    );
  }

  return (
    <div className=" bg-white/70 rounded-lg py-4 px-7 select-none">
      <div className="flex items-center">
        <CheckIcon
          className={`w-5 h-5 ${verifyed ? "fill-green" : ""}`}
        ></CheckIcon>
        <EmailIcon className="fill-dark1 ml-2 w-5 h-5 mr-[1px]"></EmailIcon>
        <div className="text-sm font-semibold text-dark1 ml-1">Email</div>
      </div>

      <TextInput
        readOnly={!!userInfo?.email || verifying}
        value={email}
        className="mt-2 ml-7"
        size="md"
        classNames={{
          input: "border-[#e7e7e7] pl-4  rounded-lg",
          rightSection: "",
        }}
        placeholder="Your email"
        rightSectionWidth={130}
        rightSection={rightSection}
        onChange={(e) => {
          setEmail(e.currentTarget.value);
        }}
      ></TextInput>
    </div>
  );
};

export default EmailVerify;
